import CardWeapon from 'components/CardWeapon';
import Resume from 'components/Resume';

export default function MainPage(){
    return(
        <>
            <Resume></Resume>
            <CardWeapon></CardWeapon>
            
        </>

    );
}